export const GLOBAL_TAG = '*';
export const STATE_CONTEXT = Symbol('STATE_CONTEXT');
export const MATCHER = Symbol('MATCHER');
export const CREATED = 'CREATED';
export const DELETED = 'DELETED';
export const UPDATED = 'UPDATED';

// Marker type bitflags
export const MARKER_GLOBAL = 1;  // 0b001
export const MARKER_SINGLE = 2;  // 0b010
export const MARKER_MANY = 4;    // 0b100
export const MARKER_EPHEMERAL = 8; // 0b1000

// Comparison result constants
export const MATCH_EXACT = 0;      // Markers are identical
export const MATCH_PARENT = 1;      // controlMarker is child of comparedMarker (parent changed)
export const MATCH_CHILD = 2;       // comparedMarker is child of controlMarker (child changed)
export const MATCH_NONE = -1;       // No relationship